import React, { useState, useMemo, useEffect } from 'react';
import { Container, Row, Col, Form, Dropdown, Card, Button,Modal, Spinner } from 'react-bootstrap';
import { ChevronDown, FileSpreadsheet, FileText, FileImage, FileType } from 'lucide-react';
import { toast, ToastContainer } from "react-toastify";
import '../../Styles/yellowcalfcss/Suppliers.css';
import { FaSearch , FaCalendarAlt, FaEye, FaEdit, FaTrashAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { simplePostCall } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';


// --- SVG Components ---
const Eye = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const Edit = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 20h9"></path>
    <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 12.5-12.5z"></path>
  </svg>
);

const Trash2 = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"></path>
    <path d="M10 11v6"></path>
    <path d="M14 11v6"></path>
    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"></path>
  </svg>
);

const mockData = [
  { id: 1, billNumber: 'cgfhgjhjh', supplier: '', billDate: '2022-03-03', dueDate: '2022-03-10', totalAmount: 268 },
  { id: 2, billNumber: '12112', supplier: '', billDate: '2022-03-21', dueDate: '2022-03-22', totalAmount: 262 },
  { id: 3, billNumber: 'new bill', supplier: '', billDate: '2022-01-25', dueDate: '2022-03-27', totalAmount: 260 },
  { id: 4, billNumber: '1712', supplier: '', billDate: '2022-03-01', dueDate: '2022-03-02', totalAmount: 252 },
  { id: 5, billNumber: '123456', supplier: '', billDate: '2022-04-01', dueDate: '2022-04-22', totalAmount: 75 },
  { id: 6, billNumber: '35523', supplier: '', billDate: '2022-05-06', dueDate: '2022-05-12', totalAmount: 32 },
  { id: 7, billNumber: '33612', supplier: '', billDate: '2022-07-12', dueDate: '2022-07-13', totalAmount: 115 },
  { id: 8, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 120 },
  { id: 9, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 10, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 11, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 12, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 13, billNumber: 'www222', supplier: '', billDate: '2024-04-30', dueDate: '2024-04-14', totalAmount: 120 }
];

export function Suppliers() {
const [filters, setFilters] = useState({
  name_search: "",
  email_search: "",
  address_search: "",
  number_search: ""
});

  const [supplierList, setSupplierList] = useState([]);
const [loading, setLoading] = useState(false);

 const [showDeleteModal, setShowDeleteModal] = useState(false);
const [isDeleting, setIsDeleting] = useState(false);
const [id, setId] = useState(null);

const handleDeleteSupplier = async () => {
  setIsDeleting(true);

  const requestBody = {
    customer_id: Number(localStorage.getItem("customer_id")),
    api_key: localStorage.getItem("api_key"),
    user_id: Number(localStorage.getItem("user_id")),
    language: "en",
    id: Number(id),
  };

  try {
    const response = await simplePostCall(
      ApiConfig.supplierDelete,
      JSON.stringify(requestBody)
    );

    if (response?.result) {
      toast.success(response?.message || "Supplier deleted successfully");
      setShowDeleteModal(false);
      fetchSupplierList();

   
    } else {
      toast.error(response?.message || "Failed to delete supplier");
    }
  } catch (error) {
    console.error("Delete supplier error:", error);
    toast.error("Network error occurred");
  } finally {
    setIsDeleting(false);
  }
};

const handleFilterChange = (field, value) => {
  const updatedFilters = { ...filters, [field]: value };
  setFilters(updatedFilters);

  // Server-side filtering
  fetchSupplierList(updatedFilters);
};


  const download = (content, filename, mimeType) => {
    const encoded = encodeURI(`data:${mimeType};charset=utf-8,${content}`);
    const link = document.createElement('a');
    link.setAttribute('href', encoded);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = (format) => {
    if (format === 'CSV') {
      const csv = "Bill Number,Supplier,Bill Date,Due Date,Total Amount\n" +
        supplierList?.map(b => `${b.billNumber},${b.supplier},${b.billDate},${b.dueDate},${b.totalAmount}`).join('\n');
      download(csv, 'paid_bills.csv', 'text/csv');
    } else if (format === 'JSON') {
      const json = JSON.stringify(supplierList, null, 2);
      download(json, 'paid_bills.json', 'application/json');
    } else {
      window.alert(`${format} export not implemented yet`);
    }
  };

  const handleViewDetails = (id) => {
    window.alert(`Viewing details for bill ID: ${id}`);
  };

    // Fetch data on load
    useEffect(() => {
      fetchSupplierList();
    }, []);
  
  const fetchSupplierList = async (updatedFilters = filters) => {
  setLoading(true);

  const customer_id = localStorage.getItem("customer_id");
  const api_key = localStorage.getItem("api_key");
  const user_id = localStorage.getItem("user_id");

  const requestBody = {
    customer_id: Number(customer_id),
    api_key: api_key,
    user_id: Number(user_id),
    language: "en",

    // ✅ REAL API FILTERS
    name_search: updatedFilters.name_search || "",
    email_search: updatedFilters.email_search || "",
    address_search: updatedFilters.address_search || "",
    number_search: updatedFilters.number_search || ""
  };

  try {
    const response = await simplePostCall(
      ApiConfig.supplierList,
      JSON.stringify(requestBody)
    );

    if (response?.result && Array.isArray(response?.data)) {
      const normalized = response.data.map((item, index) => ({
        id: index + 1,
        supplierId: item.supplier_id,
        name: item.supplier_name,
        address: item.supplier_address,
        email: item.supplier_email,
        mobile: item.supplier_mobile
      }));

      setSupplierList(normalized);
    } else {
      setSupplierList([]);
    }
  } catch (error) {
    console.error("Error fetching suppliers:", error);
    setSupplierList([]);
  } finally {
    setLoading(false);
  }
};



  return (
    <div className="suppliers-list-wrapper">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Header */}
      <div className="special-header panel-white-all">
        <h4 className="page-title">Suppliers</h4>
        <Link to="/accountant/create-supplier" className="btn btn-primary">
          Create Supplier
        </Link>
      </div>

      <div className="yc-list-body">
        {/* Filters */}
        <div className="yc-list-filter">
          <Form.Control
            type="text"
            placeholder="Supplier Name"
            value={filters.name_search}
            onChange={(e) => handleFilterChange("name_search", e.target.value)}
            className="form-control"
          />
          <Form.Control
            type="text"
            placeholder="Email"
            value={filters.email_search}
            onChange={(e) => handleFilterChange("email_search", e.target.value)}
            className="form-control"
          />
          <Form.Control
            type="text"
            placeholder="Address"
            value={filters.address_search}
            onChange={(e) => handleFilterChange("address_search", e.target.value)}
            className="form-control"
          />
          <Form.Control
            type="text"
            placeholder="Contact Number"
            value={filters.number_search}
            onChange={(e) => handleFilterChange("number_search", e.target.value)}
            className="form-control"
          />
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-6">
            <div className="yc-list-cell">Sr No</div>
            <div className="yc-list-cell">Name</div>
            <div className="yc-list-cell">Address</div>
            <div className="yc-list-cell">Email</div>
            <div className="yc-list-cell">Contact Number</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        {/* Rows */}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <Spinner />
          </div>
        ) : supplierList?.length > 0 ? (
          <div className="yc-list-row-list">
            {supplierList.map((supplier) => (
              <div key={supplier.supplierId} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-6">
                  <div className="yc-list-cell">{supplier.id}</div>
                  <div className="yc-list-cell">{supplier.name || "-"}</div>
                  <div className="yc-list-cell">{supplier.address || "-"}</div>
                  <div className="yc-list-cell">{supplier.email || "-"}</div>
                  <div className="yc-list-cell">{supplier.mobile || "-"}</div>
                  <div className="yc-list-cell yc-list-cell-actions">
                    <Link to={`/accountant/suppliers/view/${supplier.supplierId}`}>
                      <button className="yc-action-icon" title="View">
                        <FaEye />
                      </button>
                    </Link>
                    <Link to={`/accountant/update-supplier/${supplier.supplierId}`}>
                      <button className="yc-action-icon" title="Edit">
                        <FaEdit />
                      </button>
                    </Link>
                    <button
                      className="yc-action-icon yc-action-icon--danger"
                      title="Delete"
                      onClick={() => {
                        setId(supplier?.supplierId);
                        setShowDeleteModal(true);
                      }}
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No suppliers found.</div>
        )}
      </div>
      <Modal
  show={showDeleteModal}
  onHide={() => !isDeleting && setShowDeleteModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Delete Supplier</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    Are you sure you want to delete this supplier?
    <br />
    {/* <strong>This action cannot be undone.</strong> */}
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowDeleteModal(false)}
      disabled={isDeleting}
    >
      Cancel
    </Button>

    <Button
      variant="danger"
      onClick={handleDeleteSupplier}
      disabled={isDeleting}
    >
      {isDeleting ? <Spinner size="sm" /> : "Delete"}
    </Button>
  </Modal.Footer>
</Modal>
    </div>
  );
}
